<template>
	<Container :active='2'>
		<template v-for='modular in modulars'>
			<div class="carousel" v-if='modular.Code == "WSCulture001"'>
				<Carousel v-model="value1" loop autoplay :autoplay-speed='8000' dots='none'>
			        <CarouselItem v-for='item in modular.items'>
			            <a :href='configUrl(item)' class="carousel-item">
							<img class="img" :src="item.Pic">
						</a>
			        </CarouselItem>
			    </Carousel>
			    <div class="indicator">
			    	<div class="dots">
				    	<div class="dot" @mouseenter='value1=i - 1' :class='{active:i - 1==value1}' v-for='i in modular.items.length'></div>
				    </div>
			    </div>
			</div>
			<div class="culture" v-if='modular.Code == "CultureCategory"'>
				<p class="title">{{modular.Title}}<br>{{modular.TitleEn}}</p>
				<div class="items">
					<a :href='item.Href' class="item" v-for='item in modular.items'>
						<img v-lazysrc="item.Pic" :data-default='require("@/assets/defaultImg.png")'>
						<p class="name">{{item.Name}}<br>{{item.LabelEN}}</p>
					</a>
				</div>
			</div>
			<div class="hot-items" v-if='modular.Code == "WSCulture002"'>
				<div class="introduce" v-for='item in modular.items'>
					<img :src="item.Pic">
					<div class="desc">
						<p class="title">{{item.Title}}</p>
						<p class="content" v-html='item.SubTitle'>
						</p>
					</div>
				</div>
			</div>
			
		</template>
	</Container>
</template>

<script>
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				value1:0,
				modulars:[],

			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getPageConfigAction',
				'getPageConfigDetailAction',
				'getCommunityCatalogAction',
			]),
			async initData(){
				let modulars = await this.getPageConfigAction('WSCulture')
				let response1 = await this.getPageConfigDetailAction({page:'WSCulture'})
				modulars.forEach(modular=>{
					let items = response1.filter(item=>item.Module == modular.Code)
					modular.items = items
				});
				
				let response = await this.getCommunityCatalogAction('DT_WS_CultureCatalog')
				console.log(response)
				if (response.length) {
					let modular = {
						Code:'CultureCategory',
						Title:'文化',
						TitleEn:'Culture',
						items:response
					}
					modulars.splice(1, 0, modular)
				}
				this.modulars = modulars;
			},
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.culture {
		margin: auto;
		margin-top: 5.21vw;
		width: 79.17vw;
		cursor: pointer;
		margin-bottom: 40px;
		.title {
			text-align: center;
			color:$theme-color;
			font-weight: bold;
			@include fontSize($font-size-20);
		}
		.items {
			display: flex;
			justify-content: space-between;
			.item {
				width: 21.88vw;
				img {
					padding-top: 2.6vw;
					display: block;
					width:100%;
					height:21.88vw;
					object-fit: contain;
					transition: all .2s ease-in-out;
					&:hover {
						padding-top: 1.6vw;
						padding-bottom: 1.0vw;
					}
				}
				.name {
					margin-top: 1.56vw;
					@include fontSize($font-size-18);
					color:$theme-color;
					text-align: center;
					font-weight: bold;
				}
			}
		}
	}
	.introduce {
		margin: auto;
		margin-top: 5.21vw;
		width: 79.17vw;
		margin-bottom: 5.21vw;
		display: flex;
		justify-content: space-between;
		img {
			width:35.94vw;
			height:auto;
			display: block;
		}
		.desc {
			width:35.94vw;
			.title {
				margin: 3.65vw 0;
				@include fontSize($font-size-30);
			}
			.content {
				color:white;
				background-color: #8D9194;
				padding:3.65vw 2.08vw;
			}
		}
	}
	@media (max-width: 768px){
		.culture {
			width: 95vw;
			.items {
				.item {
					width: 30vw;
					img {
						height:auto;
					}
				}
			}
		}
	}
</style>